import script from "./QButton.vue?vue&type=script&setup=true&lang=js"
export * from "./QButton.vue?vue&type=script&setup=true&lang=js"

import "./QButton.vue?vue&type=style&index=0&id=420c1e9c&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-420c1e9c"]])

export default __exports__